<template>
  <div class="container py-4">
    <div class="page-card">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="mb-0 section-title-accent">Purchase orders</h4>
        <icon-button
          :func="() => (showCreate = true)"
          :icon="'plus'"
          :title="'New PO'"
          :classes="'akkurate-green-btn btn-size2'"
          :btnName="'New PO'"
        />
      </div>

      <b-table
        :items="orders"
        :fields="fields"
        small
        responsive
        :busy="loading"
        show-empty
        empty-text="No purchase orders yet"
      >
        <template #cell(totalCost)="row">
          {{ formatMoney(row.item.totalCost) }}
        </template>
        <template #cell(actions)="row">
          <b-button
            v-if="row.item.status === 'draft'"
            size="sm"
            variant="outline-primary"
            class="me-1"
            @click="submitPo(row.item.id)"
          >
            Submit
          </b-button>
          <b-button
            v-if="['draft', 'submitted'].includes(row.item.status)"
            size="sm"
            variant="outline-success"
            @click="receivePo(row.item.id)"
          >
            Receive
          </b-button>
        </template>
      </b-table>
    </div>

    <b-modal
      v-model="showCreate"
      title="Create purchase order"
      size="lg"
      @ok="createPo"
    >
      <b-form-group label="Supplier" class="mb-3">
        <b-form-select
          v-model="form.supplierId"
          class="w-100 form-select"
          placeholder="Select supplier"
          :options="supplierOptions"
        />
      </b-form-group>
      <div v-for="(line, idx) in form.items" :key="idx" class="row g-2 mb-2">
        <div class="col-6">
          <b-form-select
            v-model="line.productId"
            class="form-select"
            :options="productOptions"
          />
        </div>
        <div class="col-3">
          <b-form-input
            v-model.number="line.quantity"
            type="number"
            class="form-control"
            min="1"
            placeholder="Qty"
          />
        </div>
        <div class="col-3">
          <b-form-input
            class="form-control"
            v-model.number="line.unitCost"
            type="number"
            min="0"
            step="0.01"
            placeholder="Cost"
          />
        </div>
      </div>

      <icon-button
        :func="
          () => form.items.push({ productId: '', quantity: 1, unitCost: 0 })
        "
        :icon="'plus'"
        :title="'New PO'"
        :classes="'akkurate-green-btn btn-size2'"
        :btnName="'Add line'"
      />
      <!-- <b-button size="sm" variant="link" @click="">
        + 
      </b-button> -->

      <template #modal-footer>
        <icon-button
          :func="() => (showCreate = false)"
          :icon="'times'"
          :title="'Cancel'"
          :classes="'akkurate-danger-bg btn-size2'"
          :btnName="'Cancel'"
        />
        <icon-button
          :func="(e) => createPo(e)"
          :icon="'check'"
          :title="'Complete sale'"
          :classes="'akkurate-green-btn btn-size2'"
          :btnName="'Complete sale'"
        />
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/core/services/api.service";
import IconButton from "@/components/IconButton.vue";

export default {
  name: "PurchaseOrders",
  components: { IconButton },
  data() {
    return {
      loading: false,
      orders: [],
      suppliers: [],
      products: [],
      showCreate: false,
      form: {
        supplierId: "",
        items: [{ productId: "", quantity: 1, unitCost: 0 }],
      },
      fields: [
        { key: "poNumber", label: "PO #" },
        { key: "supplierName", label: "Supplier" },
        { key: "status", label: "Status" },
        { key: "totalCost", label: "Total" },
        { key: "actions", label: "" },
      ],
    };
  },
  computed: {
    ...mapGetters(["selectedStoreId"]),
    supplierOptions() {
      return [
        { value: "", text: "Select supplier" },
        ...this.suppliers.map((s) => ({ value: s.id, text: s.name })),
      ];
    },
    productOptions() {
      return [
        { value: "", text: "Select product" },
        ...this.products.map((p) => ({ value: p.id, text: p.name })),
      ];
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      if (!this.selectedStoreId) return;
      this.loading = true;
      try {
        [this.orders, this.suppliers, this.products] = await Promise.all([
          ApiService.get("purchase-orders", { storeId: this.selectedStoreId }),
          ApiService.get("suppliers"),
          ApiService.get("products", { storeId: this.selectedStoreId }),
        ]);
      } finally {
        this.loading = false;
      }
    },
    async createPo() {
      // bvModalEvt.preventDefault();
      try {
        await ApiService.post("purchase-orders", {
          storeId: this.selectedStoreId,
          supplierId: this.form.supplierId,
          items: this.form.items.filter((i) => i.productId),
        });
        this.showCreate = false;
        await this.load();
      } catch (e) {
        toast.fire({
          title: e?.response?.data?.message || "Create failed",
          icon: "danger",
        });
      }
    },
    async submitPo(id) {
      await ApiService.post(`purchase-orders/${id}/submit`);
      await this.load();
    },
    async receivePo(id) {
      await ApiService.post(`purchase-orders/${id}/receive`);
      await this.load();
    },
  },
};
</script>
